import * as React from 'react';
import * as ReactDom from 'react-dom';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import $ from 'jquery';
var Config: any = require('../../Config.json');

export interface CustomEditRendererState {
    isEditMode: boolean;
    isDisabled: any;
    strvalue: any;

}

var self;
var isValidStr = true;

export class GridValidateStrTextAreaCellEditorRenderer extends React.Component<any, CustomEditRendererState> {
    private inputRef: React.RefObject<HTMLTextAreaElement>;
    constructor(props: any) {
        super(props);

        this.state = {
            isEditMode: false,
            isDisabled: null,
            strvalue: props.value,

        };
        this.inputRef = React.createRef();
        self = this;
    }

    componentDidMount() {
        $('.validating-msg').hide();
        this.inputRef.current.focus();
        this.setState({ isDisabled: false });

    }
    setSaveButtonDisabled(flag) {
        this.setState({ isDisabled: flag });
    }

    isCancelAfterEnd() {

        let value = this.getValue();
        if (!this.isValid(value)) {
            return true;
        }
        return false;
    }


    isCancelBeforeStart() {
        return false;
    }


    getValue() {
        return this.state.strvalue;
    }

    isValid = function (val) {
         if(val != null && val !=""){
            isValidStr = this.props.validationCondition(val);
            if (isValidStr) {
                return true;
            } else {
                return false;
            }
           }else{
            return true;
        }
    }

    strcellValueChange(event: any) {
        let val = event.target.value;
         if(val != null && val !=''){
                var preloader = document.getElementById("strTxtclr");
                if (this.isValid(val)) {
                    preloader.classList.remove('red-bg');
                    $('.validating-msg').hide();            
          
                } else {
                    preloader.classList.add('red-bg');
                     $('.validating-msg').show();          
                }
        }
        this.setState({ strvalue: event.target.value });
    }

    componentWillReceiveProps(nextprops: any) {


    }


    public render() {
        return <div className="tooltipOverflow">
            <textarea ref={this.inputRef} className='required-editor' id="strTxtclr" maxLength={1201} cols={50}
                rows={6}  value={this.state.strvalue} onChange={e => this.strcellValueChange(e)}></textarea>
            <span id= "validating-msg" className="validating-msg"> {this.props.errorMessage} </span>
        </div>;
    }
}